import * as React from 'react';

import {
  sections,
  // utils
} from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { SectionContentLinkListIdThree } from 'components/section-content-link-list';
import { TitleAnchor } from 'components/title-anchor';
import { FormattedText, P1 } from 'components/typography';

const setTitleElement = (id: SectionContentLinkListIdThree) => {
  const mapTitleAnchorToSectionId: {
    [key in SectionContentLinkListIdThree]: {
      id: SectionContentLinkListIdThree;
      title: string;
    };
  } = {
    [SectionContentLinkListIdThree.ThingsToKeepInMind]: {
      id: SectionContentLinkListIdThree.ThingsToKeepInMind,
      title: sections.tabThreeSection.subsection1.title(),
    },

    [SectionContentLinkListIdThree.BFFProfileSharing]: {
      id: SectionContentLinkListIdThree.BFFProfileSharing,
      title: sections.tabThreeSection.subsection2.title(),
    },
  };

  return <TitleAnchor {...mapTitleAnchorToSectionId[id]} />;
};

export const getPropsSectionThreeContainer = () => {
  /**
   * @todo: add real text
   */
  return {
    sections: {
      one: {
        intro: (
          <FormattedText>
            <P1 as="p">{sections.tabThreeSection.subsection1.intro1()}</P1>
            <P1 as="p">{sections.tabThreeSection.subsection1.intro2()}</P1>
          </FormattedText>
        ),
        titleElement: setTitleElement(SectionContentLinkListIdThree.ThingsToKeepInMind),
        column1: (
          <FormattedText>
            <P1 html={sections.tabThreeSection.subsection1.column1()} as="div" />
          </FormattedText>
        ),
        column2: (
          <FormattedText>
            <P1 html={sections.tabThreeSection.subsection1.column2()} as="div" />
          </FormattedText>
        ),
        imageSrc: `${CdnImagePath}/landing/assets/photos/landing-section-1-Good-to-know.png`,
        imageAlt: '',
        imageObjectPosition: 'top center',
        goodToKnow: {
          title: sections.tabThreeSection.subsection1.goodToKnow.title(),
          content: sections.tabThreeSection.subsection1.goodToKnow.content(),
        },
      },
      two: {
        imageSrc: `${CdnImagePath}/assets/tab-03/tab-03-02.png`,
        imageAlt: '',
        imageObjectPosition: 'top center',
        title: sections.tabThreeSection.subsection2.title(),
        text: (
          <FormattedText>
            <P1 html={sections.tabThreeSection.subsection2.text1()} as="p" />
            <P1 html={sections.tabThreeSection.subsection2.text2()} as="p" />
          </FormattedText>
        ),
        titleElement: setTitleElement(SectionContentLinkListIdThree.BFFProfileSharing),
        subTitle: sections.tabThreeSection.subsection2.subTitle(),
        text2: (
          <FormattedText>
            <P1 html={sections.tabThreeSection.subsection2.text3()} as="p" />
          </FormattedText>
        ),
      },
    },
  };
};
